var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quiz-coin"},[_c('div',{staticClass:"tip"}),_c('div',{staticClass:"content",on:{"click":function($event){return _vm.linkTo('Store')}}},[_c('i'),_c('span',[_vm._v(_vm._s(_vm.amount.quizRemainNum))]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more"},[_c('span',[_vm._v("+")])])
}]

export { render, staticRenderFns }